import styled, { css } from 'styled-components';
import { theme } from "../themes";

const Styles = css`
  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: var(--color-gray-background);
    box-sizing: border-box;
  }

  body {
    color: var(--color-gray-dark);
    font-family: var(--font-family-base);
  }

  a {
    color: var(--color-secondary);
    transition: var(--base-transition);
    text-decoration: none;
  }

  button {
    cursor: pointer;
    transition: var(--base-transition);
  }

  body, html {
    min-height: 100%;
    width: 100%;
    margin: 0;
  }

  hr {
    display: block;
    height: 1px;
    border: 0;
    background-color: var(--color-gray-light);
    margin: 1rem 0;
    padding: 0;
  }

  img {
    max-width: 100%;
  }
`

export default Styles
